import {Module, Mutation, MutationAction, VuexModule} from "vuex-module-decorators";
import {CompetitionRef} from "@/modules/competition/service/CompetitionService";
import {
    CompetitionRanking,
    manageRankingService,
    PractitionerRankingResource,
    RankingMenu
} from "@/modules/competition/service/ManageRankingService";
import {CompetitionTestRef, CompetitionTestSetRef} from "@/modules/competition/service/CompetitionTestsService";
import _ from "lodash";
import {
    useCompetitionPractitionerSearchHelper
} from "@/modules/competition/views/manage/components/CompetitionPractitionerSearchHelper";

@Module({namespaced: true, name: 'competition-manage-ranking'})
export default class CompetitionManageRankingModule extends VuexModule {
    menu: RankingMenu = {} as RankingMenu
    ranking: CompetitionRanking = {} as CompetitionRanking
    viewPriorities: Array<number> = []
    viewPriority = 0

    filter: string = ""
    filteredEntries: Array<PractitionerRankingResource> = []

    @Mutation
    clearStore() {
        this.menu = {} as RankingMenu
        this.ranking = {} as CompetitionRanking
        this.viewPriorities = []
        this.filter = ""
        this.filteredEntries = []
    }

    @Mutation
    updateViewPriority(p: number) {
        this.viewPriority = p
    }

    @MutationAction
    async loadData(ref: CompetitionRef) {
        const data = await manageRankingService.getData(ref)
        return {
            menu: data.menu,
            ranking: {} as CompetitionRanking,
            filter: "",
            filteredEntries: new Array<PractitionerRankingResource>()
        }
    }

    @Mutation
    async refresh(competitionRef: CompetitionRef) {
        this.ranking = await manageRankingService.getRanking(competitionRef, this.ranking.test.ref!, this.ranking.testSet.ref!, this.ranking.rankingRef)
        this.viewPriorities = _.uniq(this.ranking.headers.map(it => it.viewPriority))
        this.viewPriority = _.min(this.viewPriorities) || 0
        this.filteredEntries = applyFilter(this.ranking, this.filter)
    }

    @MutationAction
    async select(request: SelectRequest) {
        const r = await manageRankingService.getRanking(request.competitionRef, request.testRef, request.testSetRef, request.rankingRef)
        return {
            ranking: r,
            viewPriorities: _.uniq(r.headers.map(it => it.viewPriority)),
            viewPriority: _.min(r.headers.map(it => it.viewPriority)),
            filter: "",
            filteredEntries: r.entries
        }
    }

    @MutationAction
    async deleteRanking(request: DeleteRequest) {
        await manageRankingService.deleteRanking(request.competitionRef, request.testRef, request.testSetRef, request.rankingRef)
        return {
            ranking: {},
            viewPriorities: new Array<number>(),
            filter: "",
            filteredEntries: new Array<PractitionerRankingResource>()
        }
    }

    @Mutation
    async applySearchFilter(filter: string) {
        this.filter = filter
        this.filteredEntries = applyFilter(this.ranking, this.filter)
    }
}

function applyFilter(ranking: CompetitionRanking, filter: string): Array<PractitionerRankingResource> {
    return useCompetitionPractitionerSearchHelper().search(ranking.entries, filter, (it) => it.practitioner)
}

export interface SelectRequest {
    competitionRef: CompetitionRef
    testRef: CompetitionTestRef
    testSetRef: CompetitionTestSetRef,
    rankingRef: string
}

export interface DeleteRequest {
    competitionRef: CompetitionRef
    testRef: CompetitionTestRef
    testSetRef: CompetitionTestSetRef,
    rankingRef: string
}
